import React, {useLayoutEffect} from 'react';
import {useLocation} from 'react-router-dom';

const MobileViewport = () => {
    const {key, pathname} = useLocation();

    useLayoutEffect(() => {
        const root = document.documentElement;
        const mobileQuery = window.matchMedia('(max-width: 767px), (hover: none) and (pointer: coarse)');
        const visualViewport = window.visualViewport;

        let animationFrame;

        const updateHeight = () => {
            if (!mobileQuery.matches) {
                root.style.removeProperty('--mobile-viewport-height');
                return;
            }

            // Use the layout viewport: the visual viewport also shrinks on keyboard open and pinch zoom.
            const height = `${window.innerHeight}px`;

            if (root.style.getPropertyValue('--mobile-viewport-height') !== height) {
                root.style.setProperty('--mobile-viewport-height', height);
            }
        };
        const scheduleUpdate = () => {
            cancelAnimationFrame(animationFrame);
            animationFrame = requestAnimationFrame(() => {
                updateHeight();
                // Navigation and portal scroll-lock cleanup can settle on the following frame.
                animationFrame = requestAnimationFrame(updateHeight);
            });
        };

        updateHeight();
        scheduleUpdate();
        window.addEventListener('resize', scheduleUpdate);
        window.addEventListener('pageshow', scheduleUpdate);
        visualViewport?.addEventListener('resize', scheduleUpdate);
        mobileQuery.addEventListener('change', scheduleUpdate);

        return () => {
            cancelAnimationFrame(animationFrame);
            window.removeEventListener('resize', scheduleUpdate);
            window.removeEventListener('pageshow', scheduleUpdate);
            visualViewport?.removeEventListener('resize', scheduleUpdate);
            mobileQuery.removeEventListener('change', scheduleUpdate);
            root.style.removeProperty('--mobile-viewport-height');
        };
    }, [key, pathname]);

    // Recreate only the background on soft navigation so browser chrome can resample its edge colors.
    return <div key={key || pathname} className='mobile-viewport-background' aria-hidden='true' />;
};

export default MobileViewport;
